<template>
    <section class="characteristic-history">
        <div class="characteristic-history__heading">
            <h6>Характеристика за месяц</h6>
            <b-button size="sm" variant="outline-primary" :disabled="loading || connectionUnavailable && !variants && !open" :aria-expanded="String(open)"
                @click="togglePrevious"><i class="fas fa-history mr-1" aria-hidden="true"></i>
                {{ loading ? 'Загрузка…' : open ? 'Скрыть прошлый месяц' : 'Характеристика за прошлый месяц' }}
            </b-button>
        </div>
        <p class="characteristic-history__scope">{{ record.scope_key.startsWith('group:') ? 'Общая для всех табелей группы объектов.' : 'Для этого объекта.' }} КТУ остаётся в этом табеле.</p>
        <timesheet-characteristic-view :record="displayRecord" :fields="fields" :show-values="false" />
        <small v-if="dirty" class="d-block text-muted mt-1">Авторство и сравнение обновятся после сохранения.</small>
        <div v-if="record.requires_choice" class="characteristic-history__previous">
            <p role="status">В табелях есть разные характеристики. Выберите основу общей записи.</p>
            <div v-for="variant in record.legacy_variants" :key="variant.key" class="characteristic-history__variant">
                <timesheet-characteristic-view :record="variant" :fields="fields" />
                <b-button :disabled="!editable || busy" size="sm" variant="primary" @click="$emit('use', variant, true)">Использовать эту характеристику</b-button>
            </div>
        </div>
        <div v-if="open" class="characteristic-history__previous" aria-live="polite">
            <p v-if="loading" class="mb-0"><b-spinner small /> Загружаем характеристику…</p>
            <template v-else-if="variants">
                <p v-if="!variants.length" class="mb-0">За прошлый месяц характеристики нет.</p>
                <template v-else>
                    <aside class="characteristic-history__notice" aria-label="Перед переносом характеристики">
                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                        <div>
                            <p>Проверьте и актуализируйте характеристику.</p>
                            <p><strong>Руководитель увидит сравнение с прошлым месяцем и отметку, если вы никак не изменили её текст.</strong></p>
                            <p>Нам важно видеть, что изменилось в работе сотрудника.</p>
                        </div>
                    </aside>
                    <div v-for="variant in variants" :key="variant.key" class="characteristic-history__variant">
                        <timesheet-characteristic-view :record="variant" :fields="fields" />
                        <b-button v-if="editable" :disabled="busy" variant="primary" size="sm" @click="$emit('use', variant, false)">Вставить в текущий месяц</b-button>
                    </div>
                </template>
            </template>
            <b-button v-else size="sm" variant="outline-primary" :disabled="connectionUnavailable" @click="$emit('load')">Повторить загрузку</b-button>
        </div>
    </section>
</template>
<script>
import TimesheetCharacteristicView from './TimesheetCharacteristicView.vue';
export default {
    name: 'TimesheetCharacteristicHistory',
    components: {TimesheetCharacteristicView},
    props: {record: {type: Object, required: true}, fields: {type: Array, default: () => []},
        variants: {type: Array, default: null}, loading: Boolean, editable: Boolean, busy: Boolean, dirty: Boolean, connectionUnavailable: Boolean},
    data: () => ({open: false}),
    computed: {
        displayRecord() { return this.dirty ? {...this.record, comparison: null} : this.record; }
    },
    methods: {
        togglePrevious() {
            this.open = !this.open;
            if (this.open && !this.connectionUnavailable) this.$emit('load');
        }
    }
};
</script>
<style scoped>
.characteristic-history {grid-column: 1 / -1; min-width: 0; border-top: 1px solid #dbe5ee; padding-top: .85rem;}
.characteristic-history__heading {display: flex; flex-wrap: wrap; gap: .5rem; justify-content: space-between; align-items: center;}
.characteristic-history h6 {margin: 0; font-weight: 700; color: #344e69;}
.characteristic-history__scope {font-size: .8rem; color: #5e7184; margin: .4rem 0 .55rem;}
.characteristic-history__previous {margin-top: .65rem; padding: .75rem; border: 1px solid #ccdeef; background: #f2f8fd; border-radius: .5rem;}
.characteristic-history__notice {
    display: flex; align-items: flex-start; gap: .65rem; margin-bottom: .85rem; padding: .8rem;
    border: 1px solid #e8c875; border-left: 4px solid #b77912; border-radius: .4rem;
    background: #fff8e7; color: #634609; font-size: .9rem; line-height: 1.45;
}
.characteristic-history__notice > i {flex: 0 0 auto; margin-top: .15rem; font-size: 1.15rem; color: #98660d;}
.characteristic-history__notice > div {min-width: 0;}
.characteristic-history__notice p {margin: 0;}
.characteristic-history__notice p + p {margin-top: .4rem;}
.characteristic-history__notice strong {font-weight: 700;}
.characteristic-history__variant + .characteristic-history__variant {margin-top: .75rem;}
.characteristic-history__variant > button {margin-top: .4rem;}
@media (max-width: 575px) {
    .characteristic-history__heading > button {width: 100%; white-space: normal;}
    .characteristic-history__previous {padding: .5rem;}
}
</style>
